import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Container, Row, Col, Table, Modal, Button } from "react-bootstrap";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import ico_excel_download from "../../assets/ico_excel_download.png";
import api from "../../services/api";
import ender from "../../tools/ender";
import "./styles.css";

export default function ListaContribuicoes({ history }) {
  const [audiencia, setAudiencia] = useState([]);
  const [contribuicoes, setContribuicoes] = useState([]);
  const [modalShow, setModalShow] = useState(false);
  const [original, setOriginal] = useState('');
  const [texto, setTexto] = useState('');
  const [justificativa, setJustificativa] = useState('');
  const [arquivo, setArquivo] = useState('');
  const [data, setData] = useState('');
  const [participante, setParticipante] = useState('');
  const [instituicao, setInstituicao] = useState('');
  const [classifica, setClassifica] = useState('DT_SEGUNDOS');
  const [ascendente, setAscendente] = useState(true);
  const { consulta_id } = useParams();
  const [idAudiencia] = useState(consulta_id);

  useEffect(() => {
    async function loadAudiencia() {
      if (!isNaN(idAudiencia)) {
        const response = await api.get(`/api/audiencia/${idAudiencia}`);
        setAudiencia(response.data);
      }
    }
    loadAudiencia();
  }, [idAudiencia]);

  useEffect(() => {
    async function loadContribuicoes() {
      if (!isNaN(idAudiencia)) {
        const response = await api.get(
          `/api/audiencia/contribparticipante/${idAudiencia}`
        );
        setContribuicoes(response.data);
      }
    }
    loadContribuicoes();
  }, [idAudiencia]);

  function handleClickDetalhe(id){
    setOriginal(contribuicoes[id].DS_TEXTO_ORIGINAL);
    setTexto(contribuicoes[id].DS_TEXTO_INSTITUCIONAL);
    setJustificativa(contribuicoes[id].DS_TEXTO_JUSTIFICATIVA);
    setArquivo(contribuicoes[id].CA_ARQUIVO);
    setParticipante(contribuicoes[id].NO_PARTICIPANTE);
    setInstituicao(contribuicoes[id].NO_INSTITUICAO);
    setData(contribuicoes[id].DT_CADASTRO);
    setModalShow(true);
  }

  function handleClassificacao(cpo){
    setClassifica(cpo);
    setAscendente(!ascendente);
  }

  function formulaClassicacao(a, b) {
    if (ascendente){
      return (a[classifica] < b[classifica] ? -1 : (a[classifica] > b[classifica]? 1 : 0));
    } else {
      return (a[classifica] > b[classifica] ? -1 : (a[classifica] < b[classifica]? 1 : 0));
    }
  }

  const exportExcel = () => {
    const dataToExport = contribuicoes.map((contrib) => ({
      Data: contrib.DT_CADASTRO,
      Dispositivo: contrib.DS_TEXTO_ORIGINAL,
      Contribuição: contrib.DS_TEXTO_INSTITUCIONAL,
      Justificativa: contrib.DS_TEXTO_JUSTIFICATIVA,
      Participante: contrib.NO_PARTICIPANTE,
      Instituição: contrib.NO_INSTITUICAO,
    }));

    const worksheet = XLSX.utils.json_to_sheet(dataToExport);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Contribuições");

    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, `contribuicoes_${idAudiencia}.xlsx`);
  };

  return (
    <>
      <Container>
        <Row>
          <Col sm={12}>
            <div className="voltar">
              <a href={`/Consulta/${idAudiencia}`}>voltar</a>
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <h3>
              {audiencia.length > 0 ? audiencia[0].DS_MODALIDADE + " nº " : ""}
              {audiencia.length > 0 ? audiencia[0].NU_AUDIENCIA + "/" + audiencia[0].NU_AUDIENCIA : ""}
              &nbsp;- Relação de Contribuições Recebidas - {contribuicoes.length} &nbsp;Contribuições recebidas
            </h3>
          </Col>
          <Col sm={2} className="linhaBotao">
            <div
              onClick={exportExcel}
              style={{ cursor: 'pointer', display: 'inline-block' }}
              data-toggle="tooltip"
              title="Baixe aqui o Excel com todas as contribuições recebidas"
            >
              <img src={ico_excel_download}
                alt="Exportação para Excel"
                className="iconeExporta" />
            </div>
          </Col>
        </Row>

        <Row>
          <Col sm={12}>
            <Table id="tableContent" striped bordered hover size="sm">
              <thead>
                <tr className="tituloContribuicao">
                  <th width="20%">
                    <span className="Aponta" onClick={() => handleClassificacao("DT_SEGUNDOS")}>
                      Data &nbsp;&nbsp;
                      {classifica === "DT_SEGUNDOS" ? (ascendente ? <FaChevronUp /> : <FaChevronDown />) : ""}
                    </span>
                  </th>
                  <th width="20%">
                    <span className="Aponta" onClick={() => handleClassificacao("DS_TEXTO_ORIGINAL")}>
                      Dispositivo &nbsp;&nbsp;
                      {classifica === "DS_TEXTO_ORIGINAL" ? (ascendente ? <FaChevronUp /> : <FaChevronDown />) : ""}
                    </span>
                  </th>
                  <th width="20%">
                    <span className="Aponta" onClick={() => handleClassificacao("DS_TEXTO_INSTITUCIONAL")}>
                      Contribuição &nbsp;&nbsp;
                      {classifica === "DS_TEXTO_INSTITUCIONAL" ? (ascendente ? <FaChevronUp /> : <FaChevronDown />) : ""}
                    </span>
                  </th>
                  <th width="20%">
                    <span className="Aponta" onClick={() => handleClassificacao("DS_TEXTO_JUSTIFICATIVA")}>
                      Justificativa &nbsp;&nbsp;
                      {classifica === "DS_TEXTO_JUSTIFICATIVA" ? (ascendente ? <FaChevronUp /> : <FaChevronDown />) : ""}
                    </span>
                  </th>
                  <th width="20%">
                    <span className="Aponta" onClick={() => handleClassificacao("NO_PARTICIPANTE")}>
                      Participante / Instituição &nbsp;
                      {classifica === "NO_PARTICIPANTE" ? (ascendente ? <FaChevronUp /> : <FaChevronDown />) : ""}
                    </span>
                  </th>
                </tr>
              </thead>
              <tbody>
                {contribuicoes.sort((a, b) => formulaClassicacao(a, b)).map((contrib, index) => (
                  <tr key={contrib.ID_CONTRIBUICAO} onClick={() => handleClickDetalhe(index)}>
                    <td>{contrib.DT_CADASTRO}</td>
                    <td>{contrib.DS_TEXTO_ORIGINAL.substr(0, 150)}</td>
                    <td>{contrib.DS_TEXTO_INSTITUCIONAL.substr(0, 150)}</td>
                    <td>{contrib.DS_TEXTO_JUSTIFICATIVA.substr(0, 150)}</td>
                    <td>{contrib.NO_PARTICIPANTE + "/" + contrib.NO_INSTITUICAO}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Col>
        </Row>

        <Modal show={modalShow} onHide={() => setModalShow(false)} size="lg" aria-labelledby="contained-modal-title-vcenter-lg" animation={true}>
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
              Detalhamento da Contribuição
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Container>
              <div className="contribuicao">
                <label><strong>Data da contribuição:&nbsp;</strong></label>{data}
                <label><strong>Participante:&nbsp;</strong></label>{participante}
                <label><strong>Instituição:&nbsp;</strong></label>{instituicao}
                <label><strong>Dispositivo:</strong></label>{original}
                <label><strong>Contribuição:</strong></label>{texto}
                <label><strong>Justificativa:&nbsp;</strong></label>{justificativa}
                <label><strong>Arquivo:&nbsp;</strong></label>
                <a href={ender.file(arquivo)} target="_blank" rel="noopener noreferrer">
                  {arquivo}<br />
                </a>
              </div>
            </Container>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setModalShow(false)}>Cancelar</Button>
          </Modal.Footer>
        </Modal>
      </Container>
    </>
  );
}
